import React, { PureComponent, Fragment } from 'react';
import { Grid, withStyles } from '@material-ui/core';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import parseQuerystring from '../../../helpers/parseQuerystring';
import AutocompleteInput from '../../shared/Inputs/Autocomplete';
import TextFieldInput from '../../shared/Inputs/TextField';
import OutlinedSelectChippedInput from '../../shared/Inputs/OutlinedSelectChipped';
import PickCustomDateModal from '../../shared/Inputs/PickCustomDateModal';
import CollapseWrapper from '../../shared/CollapseWrapper.js';

import _debounce from 'lodash/debounce';
import _find from 'lodash/find';
import _pickBy from 'lodash/pickBy';
import _pick from 'lodash/pick';
import _replace from 'lodash/replace';

import combineStyles from '../../../helpers/combineStyles';
import SpacingStyles from '../../../styles/helpers/spacing';

import { filterListFuzzyly } from '../../../helpers/utilityFunctions';

import { DEFAULT_DEBOUNCE_DELAY } from '../../../constants/request_constants';
import { CUSTOM_DATE } from './constants';

import {
  typeOptions,
  statusOptions,
  originalDateOptions,
  dateOptions
} from './dropdownOptions';

// import generateSearchRequest from 'sequelize-search-builder-client';
class InsuranceFilters extends PureComponent {
  state = {
    id: '',
    contractId: '',
    identification: '',
    type: 'todas',
    status: 'todas',
    registeredAt: 'todas',
    openPickCustomDate: null,
    customDate: CUSTOM_DATE
  };

  componentDidMount() {
    const query = parseQuerystring(this.props);
    this.setState({
      ...this.state,
      ...query
    });
  }

  _searchCallback = _debounce(
    (attribute, value) => {
      this.setState({ [attribute]: value, page: 0 }, this._handleChangeFilter);
    },
    DEFAULT_DEBOUNCE_DELAY,
    {
      leading: false,
      trailing: true
    }
  );

  _handleChange = ({ target: { name, value } }) => {
    this._searchCallback(name, value);
  };

  _handleSelectChange = ({ target: { name, value } }) =>
    this.setState({ [name]: value }, this._handleChangeFilter);

  _handleAutoSuggest = name => (event, { newValue }) => {
    this.setState({ [name]: newValue }, (name, newValue) =>
      this._searchCallback(name, newValue)
    );
  };

  _handleDateFilter = ({ target: { name, value } }) => {
    if (value === this.state.customDate) {
      this.setState({ openPickCustomDate: name });
    } else {
      this.setState(
        { [name]: value, customDate: CUSTOM_DATE },
        this._handleChangeFilter
      );
    }
  };

  _handleDateRangeFilter = ({ target: { name, value } }) => {
    const customDate = !_find(
      originalDateOptions,
      availableOption => availableOption.value === value
    )
      ? value
      : CUSTOM_DATE;
    this.setState(
      { [name]: value, openPickCustomDate: null, customDate },
      this._handleChangeFilter
    );
  };

  _handleClosePickCustomDate = () =>
    this.setState({ openPickCustomDate: null });

  _handleChangeFilter = () =>
    this.props.onChangeFilter(this._getFilterParams());

  _getFilterParams = () => {
    const filterParams = _pick(
      _pickBy(this.state, filter => !!filter && filter != 'todas'),
      ['id', 'contractId', 'registeredAt', 'identification', 'type', 'status']
    );
    return filterParams;
  };

  render() {
    const { classes } = this.props;
    return (
      <CollapseWrapper
        filter={true}
        body={
          <Fragment>
            <Grid container spacing={16}>
              <Grid item xs={6} sm={2}>
                <TextFieldInput
                  id="id"
                  name="id"
                  value={this.state.id}
                  onChange={this._handleChange}
                  label="# Servicio"
                  type="number"
                  fullWidth
                  margin="normal"
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={6} sm={2}>
                <TextFieldInput
                  id="contractId"
                  name="contractId"
                  value={this.state.contractId}
                  onChange={this._handleChange}
                  label="# Contrato"
                  type="number"
                  fullWidth
                  margin="normal"
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={6} sm={2}>
                <OutlinedSelectChippedInput
                  label={'Fecha'}
                  name={'registeredAt'}
                  options={dateOptions(
                    this.state.customDate,
                    this.state.registeredAt
                  )}
                  value={this.state.registeredAt}
                  classes={{
                    root: classes.selectRoot,
                    filterColor: classes.filterColor
                  }}
                  inputLabel={'Delivery Date'}
                  onChange={this._handleDateFilter}
                  withChip={false}
                />
              </Grid>
              <Grid item xs={6} sm={2}>
                <TextFieldInput
                  id="identification"
                  name="identification"
                  value={this.state.identification}
                  onChange={this._handleChange}
                  label="# Identificación"
                  type="number"
                  fullWidth
                  margin="normal"
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={6} sm={2}>
                <OutlinedSelectChippedInput
                  label={'Tipo'}
                  classes={{
                    root: classes.selectRoot,
                    filterColor: classes.filterColor
                  }}
                  name={'type'}
                  options={typeOptions}
                  onChange={this._handleSelectChange}
                  inputLabel={'Type'}
                  value={this.state.type}
                  withChip={false}
                />
              </Grid>
              <Grid item xs={6} sm={2}>
                <OutlinedSelectChippedInput
                  label={'Estado'}
                  classes={{
                    root: classes.selectRoot,
                    filterColor: classes.filterColor
                  }}
                  name={'status'}
                  options={statusOptions}
                  onChange={this._handleSelectChange}
                  inputLabel={'Status'}
                  value={this.state.status}
                  withChip={false}
                />
              </Grid>
            </Grid>
            {!!this.state.openPickCustomDate && (
              <PickCustomDateModal
                name={this.state.openPickCustomDate}
                onClose={this._handleClosePickCustomDate}
                onSave={this._handleDateRangeFilter}
                value={this.state.registeredAt}
              />
            )}
          </Fragment>
        }
      />
    );
  }
}

const styles = theme => ({});

export default compose(
  withRouter,
  withStyles(combineStyles(styles, SpacingStyles), { withTheme: true })
)(InsuranceFilters);
